import { SlCopyButton } from '@shoelace-style/shoelace/dist/react'
import cx from 'classnames'
import { useEffect, useState } from 'react'

import { useBeamSelector } from '../../hooks'
import { BeamTooltip } from '../../stories/BeamTooltip'
import { AccountType, TUser } from '../../utils/types'

interface DeveloperDetailsBlockProps {
  data: {
    label: string
    value: any
  }[]
}

enum DevDetailsStatusEnum {
  open = 'open',
  closed = 'closed',
}

export const DeveloperDetailsBlock = ({ data }: DeveloperDetailsBlockProps) => {
  const [expanded, setExpanded] = useState<boolean>(true)
  const user: TUser | undefined = useBeamSelector(({ user }) => user)

  useEffect(() => {
    localStorage.getItem('dev_details') === DevDetailsStatusEnum.open
      ? setExpanded(true)
      : setExpanded(false)
  }, [])

  if (user?.accountType !== AccountType.internal) {
    return null
  }

  function handleExpandButtonClick() {
    setExpanded(prev => {
      const newStatus = !prev
      localStorage.setItem(
        'dev_details',
        newStatus ? DevDetailsStatusEnum.open : DevDetailsStatusEnum.closed
      )

      return newStatus
    })
  }

  // TODO: We will find another way to display this in an non-intrusive way in a sec...
  return <></>

  return (
    <div className={'bg-charcoal-100 rounded-base p-4 fixed top-0 right-0 z-50 max-w-[33vw]'}>
      <div>
        <BeamTooltip content={'Expand Developer Details'}>
          <button className={'text-lg'} onClick={handleExpandButtonClick}>
            {expanded ? <>⏫</> : <>⏬️</>}
          </button>
        </BeamTooltip>
      </div>
      <div
        className={cx('overflow-hidden', {
          hidden: !expanded,
          'w-auto h-auto': expanded,
        })}>
        <h1 className={'my-0 text-2xl'}>🚧Developer Details🚧</h1>
        {data.map(({ label, value }, index) => {
          return (
            <>
              <div className={'mb-2'}>
                <strong>{label}: </strong>
                <br />
                <code className={'text-cherry-600 bg-light-grey'}>{value}</code>{' '}
                <SlCopyButton value={value} />
              </div>
              {index === data.length - 1 ? <></> : <div className={'bg-black h-[1px] w-full'} />}
            </>
          )
        })}
      </div>
    </div>
  )
}
